
import { getTokenClientes } from "../Store/storages/AuthenticationStorage";
import { apiClientes } from "../config/api";
import { ReceitaDigitalData } from "../interfaces/props/SaudeOnline/ReceitaDigital/ReceitaDigitalData";

export const getListaReceitaDigital = async (): Promise<ReceitaDigitalData[]> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes.get('/AnexosProntu/GetListaReceitaDigital', {
        headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
      });
      if (response?.data) {
        const result = response.data
          .map((r: { idAnexoProntu: any; 
                      nomePrestador: any; 
                      dtHoraInclusao: any; }) => ({
          idAnexo: r.idAnexoProntu,
          nomeSolicitante: r.nomePrestador,
          dtEmissao: r.dtHoraInclusao
        }))
        return resolve(result);
      } else {
        reject(response);
      }
      
    } catch (e) {
      reject(e);
    }
  })
}

export const getAnexoProntuario = async (id: string): Promise<string | null> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes.get(`/AnexosProntu/GetAnexoProntuario?idAnexo=${id}`, {
        headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
      });
      if (response?.data) {
        resolve(response.data.anexoBase64);
      } else {
        reject(response);
      }
    } catch (e) {
      reject(e);
    }
  })
}